import { GetLogProcessResultService } from './api-services/get-log-process-result.service';
import { KYMW0D01Module } from './../kymw0d01/kymw0d01.module';
import { DeleteLogProcessResultService } from './api-services/delete-log-process-result.service';
import { MakeLogDataService } from './api-services/make-log-data.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW0D00Component } from './kymw0d00.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';

/**
 * 処理ログ画面 モジュール設定クラス
 *
 * @export KYMW0D00Module
 * @class KYMW0D00Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    KYMW0D01Module
  ],
  declarations: [
    KYMW0D00Component,
  ],
  providers: [
    MakeLogDataService,
    DeleteLogProcessResultService,
    GetLogProcessResultService
  ],
})
export class KYMW0D00Module {
}
